(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-redux/assets/match-info-actions.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-redux/assets/match-info-actions.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  jupiter
} = svs.core;
const {
  createAsyncThunk,
  createAction
} = RTK;
const {
  normalizeEvent
} = svs.components.sportinfo.matchInfoRedux;
const {
  normalizeEventTypeId
} = svs.components.sportinfo.common.helpers;
const {
  EventTypes,
  EventTypeId,
  OutcomeToAlphabeticStrings,
  EventTypeDistributionsFallback
} = svs.components.sportinfo.common.constants;
const logger = svs.core.log.getLogger('match-info:match-info-actions');
const normalize1X2OddsItems = eventType => {
  if (eventType.length === 0) {
    return null;
  }
  return eventType.reduce((acc, outcome) => {
    acc[OutcomeToAlphabeticStrings[outcome.outcome]] = outcome.value;
    return acc;
  }, {});
};
const normalizeOddsResponse = (oddsResponse, productId, eventNumber, drawNumber) => _objectSpread(_objectSpread({}, oddsResponse), {}, {
  eventTypes: oddsResponse === null || oddsResponse === void 0 ? void 0 : oddsResponse.eventTypes.map(eventType => {
    const eventTypeId = normalizeEventTypeId({
      eventTypeId: eventType.eventTypeId,
      participantType: eventType.participantType,
      productId
    });
    const distribution = [];
    const startOdds = [];
    eventType.draws.map(draw => _objectSpread(_objectSpread({}, draw), {}, {
      events: draw.events.forEach(event => {
        if (eventTypeId === EventTypeId.HEAD_TO_HEAD && event.eventNumber !== eventNumber) {
          return null;
        }
        distribution.push({
          distribution: event.distribution,
          drawNumber: draw.drawNumber || EventTypeDistributionsFallback,
          eventNumber: event.eventNumber,
          productId: draw.productId,
          productName: draw.productName
        });
        if (draw.drawNumber === drawNumber) {
          event.startOdds.forEach(startOddsItem => {
            startOdds.push(startOddsItem);
          });
        }
      })
    }));
    return _objectSpread(_objectSpread({}, eventType), {}, {
      odds: eventType.odds.odds,
      favorite: eventType.odds.favourite,
      eventTypeId,
      distribution,
      startOdds
    });
  })
});
const normalizeDraws = draws => {
  if (!draws.length) {
    return [{
      distribution: [],
      startOdds: []
    }];
  }
  return draws.map(draw => {
    const {
      events
    } = draw;
    return events.map(event => _objectSpread(_objectSpread({}, event), {}, {
      startOdds: normalize1X2OddsItems(event.startOdds),
      distribution: _objectSpread(_objectSpread({}, normalize1X2OddsItems(event.distribution)), {}, {
        drawNumber: draw.drawNumber || EventTypeDistributionsFallback,
        eventNumber: event.eventNumber,
        productName: draw.productId
      }),
      drawNumber: draw.drawNumber || EventTypeDistributionsFallback,
      productName: draw.productId
    }));
  });
};
const normalizeOdds = oddsResponse => {
  let normalizedOdds = oddsResponse.eventTypes.map(_ref => {
    let {
      eventSubType,
      eventType,
      eventTypeId,
      odds,
      favorite,
      draws
    } = _ref;
    if (eventType === EventTypes.EvenType1X2) {
      const drawsResponse = normalizeDraws(draws);
      return _objectSpread({
        eventSubType,
        eventTypeId,
        eventType,
        odds: normalize1X2OddsItems(odds),
        favorite: normalize1X2OddsItems(favorite)
      }, drawsResponse.pop());
    }
    logger.debug("Trying to parse odds for unsupported event type: ".concat(eventType));
    return false;
  }).filter(Boolean);
  if (!normalizedOdds.length) {
    normalizedOdds = [{
      eventSubType: EventTypes.EvenType1X2,
      eventType: null,
      odds: null,
      startOdds: null,
      favorite: null,
      distribution: null
    }];
  }
  return normalizedOdds;
};
const fetchMatchInfoService = _ref2 => {
  let {
    matchId,
    productId,
    eventNumber,
    drawNumber
  } = _ref2;
  return new Promise((resolve, reject) => {
    const paths = ["/sport/1/sportevent/".concat(matchId), "/sport/2/sportevent/".concat(matchId, "/odds")];
    jupiter.get(paths, data => {
      const [eventResponse, oddsResponse] = data.responses;
      const normalizedOddsResponse = normalizeOddsResponse(oddsResponse, productId, eventNumber, drawNumber);
      const normalizedOdds = normalizeOdds(normalizedOddsResponse);

      resolve([eventResponse.error ? eventResponse : normalizeEvent(eventResponse.sportEvent, normalizedOdds[0].distribution), _objectSpread(_objectSpread({}, normalizedOddsResponse), {}, {
        oddsInfo: normalizedOdds[0]
      })]);
    }, error => {
      reject(error);
    });
  });
};
const fetchMatchDataService = matchId => new Promise((resolve, reject) => {
  const path = "/sport/1/sportevent/".concat(matchId);
  jupiter.get(path, data => {
    resolve(data);
  }, error => {
    reject(error);
  });
});
const fetchMatchInfo = createAsyncThunk('fetchMatchInfo', _ref3 => {
  let {
    matchId,
    productId,
    eventNumber,
    drawNumber
  } = _ref3;
  return fetchMatchInfoService({
    matchId,
    productId,
    eventNumber,
    drawNumber
  });
});
const fetchMatchData = createAsyncThunk('fetchMatchData', matchId => fetchMatchDataService(matchId));
const updateMatchOdds = createAction('updateMatchOdds', (matchId, oddsResponse) => ({
  payload: {
    matchId,
    odds: _objectSpread(_objectSpread({}, oddsResponse), {}, {
      oddsInfo: normalizeOddsResponse(oddsResponse)[0]
    })
  }
}));
setGlobal('svs.components.sportinfo.matchInfoRedux.actions', {
  fetchMatchInfo,
  fetchMatchData,
  updateMatchOdds
});

 })(window);